var map = {
	"./04-电子病历.svg": 9339,
	"./05-处方处置.svg": 2648,
	"./07-预约挂号.svg": 758,
	"./09-发布公告.svg": 8034,
	"./11-在线复诊.svg": 236,
	"./32-处方模版.svg": 4079,
	"./34-套餐服务.svg": 5361,
	"./38-服务包.svg": 8170,
	"./40-财务统计.svg": 8845,
	"./45-关于我们.svg": 522,
	"./home_在线预约.svg": 7903,
	"./会员卡.svg": 9047,
	"./医生团队.svg": 3723,
	"./历史病历.svg": 915,
	"./口腔百科.svg": 9700,
	"./在线预约.svg": 8166,
	"./患者.svg": 5814,
	"./手机.svg": 9340,
	"./接诊医生.svg": 4128,
	"./治疗项目.svg": 697,
	"./消费中心.svg": 5173,
	"./系统消息.svg": 1681,
	"./系统设置.svg": 4591,
	"./联系诊所.svg": 9478,
	"./诊所介绍.svg": 6744,
	"./诊所导航.svg": 4643,
	"./诊所活动.svg": 627,
	"./诊疗项目.svg": 9118,
	"./预约中心.svg": 6036,
	"./预约备注.svg": 3807,
	"./预约日期.svg": 5810,
	"./预约时段.svg": 29,
	"./预约类型.svg": 6377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;